import script from "./HeaderArea.vue?vue&type=script&lang=ts&setup=true"
export * from "./HeaderArea.vue?vue&type=script&lang=ts&setup=true"

import "./HeaderArea.vue?vue&type=style&index=0&id=5d41a4ca&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5d41a4ca"]])

export default __exports__